
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Ayan Biswas",
  title: "Hi all, I'm Ayan",
  subTitle: emoji("A linker between IT and Electronics domain🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."),
  resumeLink: "https://docs.google.com/document/d/1hd4hNpOVgSqLLxA3Hissa2h201h35J9O5P9RVHinII8/edit?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/ayan-biswas0412",
  linkedin: "https://www.linkedin.com/in/ayanbiswas-juetceug/",
  gmail: "ayanbiswas184@gmail.com",
  facebook: "https://www.facebook.com/biswasAyan184",
  medium: "https://medium.com/@ayanbiswas184",
  stackoverflow: "https://stackoverflow.com/users/13673849/ayan-biswas"
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "What i do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Develop highly efficient RESTFull APIs for your web and mobile applications"),
    emoji("⚡ Progressive Web Applications and React Native Mobile Applications"),
    emoji("⚡ Integration of third party services such as GCP/ AWS / heroKu"),
    emoji("⚡ Full Stack applications based on Firebase and GCP Services")
  ],

/* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ]
};

// Your education background

const educationInfo = {
  viewEducation: true, // Set it to true to see education section
  schools: [
    {
      schoolName: "Jadavpur University",
      logo: require("./assets/images/julogo.png"),
      subHeader: "Bachelor of Engineering in Electronics and Telecommunication Engineering",
      duration: "September 2019 - Till Date",
      desc: "Participated in a number of campus and outside competetions and hackathons",
      descBullets: [
        "Participated in National Innovation Contest 2020 by MHRD Innovation Cell and Prototype selected for second round",
        "First Position in ML Hackathon organized by IEEE Student branch of Jadavpur University",
        "First Position in White Collar 2.0 and Technocraft two business case challenge and pitching event organized by Jadavpur University Entrepreneurship Cell"
      ]
    }
  ]
}

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Frontend/Design",  //Insert stack or technology you have experience in
      progressPercentage: "60%"  //Insert relative proficiency in percentage
    },
    {
      Stack: "C++ Programming",
      progressPercentage: "60%"
    },
    {
      Stack: "git and Github",
      progressPercentage: "90%"
    }
  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Participated in Innovation Contest 2020 by MHRD IIC and Prototype selected for second round",
        "Class representative of the ETCE UG Batch (2019-23)"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "ayan-biswas0412", // Change to your github username to view your profile in Contact Section.
  showGithubProfile :"true" // Set true or false to show Contact profile using Github, defaults to false
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/voltroph-new.webp"),
      link: "https://www.voltroph.com/"
    },
    {
      image: require("./assets/images/dailyciousdabba.webp"),
      link: "https://www.dailyciousdabba.tech/"
    }
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Completed the Hacktoberfest challenge!",
      subtitle: "A great open source journey in the month of October 2020",
      image: require("./assets/images/hacktoberfest2020-new.svg"),
      footerLink: [
        { name: "Hacktoberfest Blog", url: "https://dev.to/ayanbiswas0412/hacktoberfest-challenge-done-and-dusted-5cgc" },
        { name: "Github Repo", url: "https://github.com/indeplot/indeplot" },
        { name: "Hacktoberfest Badge", url: "https://dev.to/badge/hacktoberfest-2020" }

      ]
    },
    {
      title: "IIC Online Sessions on IPR and Startups",
      subtitle: "IIC Online Sessions conducted by Institution's Innovation Council (IIC) of MHRD's Innovation Cell, New Delhi to promote Innovation, IPR, Entrepreneurship, and Start-ups among HEIs from",
      image: require("./assets/images/iic-logo.png"),
      footerLink: [
        { name: "See Certificate", url: "https://drive.google.com/file/d/1n6XKULap6HA2TjFbwqCDzeAiVrj_lm3Q/view?usp=sharing" }
      ]
    }
  ]
};

// Blogs Section

const blogSection = {

  title: "Blogs",
  subtitle: "I love to share my knowledge to the large developer community",

  blogs: [
    {
      url: "https://dev.to/ayanbiswas0412/hacktoberfest-challenge-done-and-dusted-5cgc",
      title: "Open Source Experience with Hacktoberfest 2020",
      description: "Developing with indeplot community was a great experience"
    },
    {
      url: "https://medium.com/@ayanbiswas184/a-simple-face-detection-program-using-python-opencv-f0643dc46821",
      title: "A simple face detection program using python (opencv)",
      description: "Computer vision and machine learning have really started to take off"
    },
    {
      url: "https://medium.com/@ayanbiswas184/how-to-install-git-in-ubuntu-18-04lts-and-start-working-b4ea4274e335",
      title: "How to install Git in ubuntu",
      description: "Git is a distributed revision control system with an emphasis on speed, data integrity, and support for distributed, non-linear workflows."
    }

  ]
};

// Talks Sections

const talkSection = {
  title: "My Presentations",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

  talks: [
    {
      title: "Quarantine Monitor App",
      subtitle: "National Innovation Contest 2020, MHRD Innovation Cell, AICTE",
      slides_url: "https://drive.google.com/file/d/1LxOhpBqOfpMsUJPNodOgAahg5SjnVGmu/view?usp=sharing",
      event_url: "https://youtu.be/ufSc5hqrN2s"
    }
  ]
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: socialMediaLinks.gmail
};

//Twitter Section

const twitterDetails = {

  userName : "AYANBIS78398228"//Replace "twitter" with your twitter username without @

};
export { greeting, socialMediaLinks, skillsSection, educationInfo, techStack, workExperiences, openSource, bigProjects, achievementSection, blogSection, talkSection, podcastSection, contactInfo , twitterDetails};
